
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'notice',
components: {
XHeader,
Actionsheet
},
directives: {
TransferDom
},
data () {
return {
title: this.$route.meta.title,
id: this.$route.params.id,
menus: {
menu1: '<div class="share-item"><i class="icon icon-wechat"></i><span class="text">朋友圈</span></div>',
menu2: '<div class="share-item"><i class="icon icon-wechat-o"></i><span  class="text">发送好友</span></div>',
menu3: '<div class="share-item"><i class="icon icon-QQspace"></i><span  class="text">QQ空间</span></div>',
menu4: '<div class="share-item"><i class="icon icon-QQ"></i><span  class="text">QQ</span></div>',
menu5: '<div class="share-item"><i class="icon icon-sina"></i><span  class="text">新浪微博</span></div>'
},
showMenus: false,
info: ''
}
},
computed: {
},
created () {
},
mounted () {
this.$vux.loading.show({
text: '加载中'
})
this.getDetail()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
click (key) {
console.log(key)
},
share () {
this.showMenus = true
},
getDetail () {
let params = {}
params.id = this.id
params.isQueryContent = 1
params.isExpire = 1
this.$api.get('/notice', params, r => {
this.$vux.loading.hide()
this.info = r.data[0]
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/notice/noticeDetail.vue